module.exports = __webpack_public_path__ + "img/OverseaMember31.1fca5449.jpg";